export const getCurrentYear = () => new Date().getFullYear();

export const truncateWithTooltip = (value, maxLength = 20) => {
  if (!value || value.length <= maxLength) return <span>{value}</span>;
  return <span title={value}>{value.slice(0, maxLength)}...</span>;
};

export const truncateText = (value, maxLength = 20) => {
  if (!value || value.length <= maxLength) return value;
  return `${value.slice(0, maxLength)}...`;
};
